const accEndpoint = process.env.REACT_APP_ACCOUNT_ENDPOINT
const platformEndpoint = process.env.REACT_APP_PLATFORM_ENDPOINT
const socket = process.env.REACT_APP_SOCKET
const docs = process.env.REACT_APP_DOCS_ENDPOINT
export const prod = process.env.REACT_APP_PROD

export const USER_PLATFORM_V1 = `${accEndpoint}/v1/accounts`

export const USER_ACCOUNTS = USER_PLATFORM_V1
export const USER_VERIFICATIONS = `${USER_PLATFORM_V1}/verifications`

export const DESK_ACCOUNT_V1 = `${platformEndpoint}/v1/desk`
export const USER_USERS = `${USER_PLATFORM_V1}/users`
export const ACCOUNT_USERS = `${DESK_ACCOUNT_V1}/rpc/users`

export const DESK_DESK = DESK_ACCOUNT_V1
export const DESK_CONTACTS = `${DESK_ACCOUNT_V1}/contacts`
export const DESK_COMPANY = `${DESK_ACCOUNT_V1}/companies`
export const DESK_MAILBOXES = `${DESK_ACCOUNT_V1}/mailboxes`
export const DESK_CONVERSATIONS = `${DESK_ACCOUNT_V1}/conversations`
export const DESK_VERIFICATIONS = `${DESK_ACCOUNT_V1}/verifications`
export const DESK_ATTACHMENTS = `${DESK_ACCOUNT_V1}/attachments`
export const DESK_SETTING = `${DESK_ACCOUNT_V1}/settings`
export const DESK_TASK = `${DESK_ACCOUNT_V1}/tasks`
export const DESK_ASSET = `${DESK_ACCOUNT_V1}/assets`
export const DESK_ROLE = `${DESK_ACCOUNT_V1}/rpc`
export const DESK_CLIENT_PORTAL = `${DESK_ACCOUNT_V1}/client-portal`
// export const DESK_ANALYTICS = DESK_ACCOUNT_V1 + "/analytics"
export const DESK_CHANNEL = `${platformEndpoint}/channels`
export const DESK_CHANNEL_V1 = `${platformEndpoint}/v1/channels`
// export const DESK_ANALYTICS = DESK_ACCOUNT_V1 + "/analytics";
export const DESK_EMAIL_INTEGRATION = `${DESK_ACCOUNT_V1}/email-integration`

export const DESK_ANALYTICS = `${platformEndpoint}/v1/desk-analytics/analytics`

export const FORM = `${platformEndpoint}/v1/forms`

export const CHANNELS = `${platformEndpoint}/v1/channels`

export const DOCS = `${docs}/v1/docs`

export const DOCS_ANALYTICS = `${DOCS}/analytics`
export const DESK_INTEGRATIONS = `${platformEndpoint}/v1/integrations`

export const SOCKET = socket

export const STATUS_PAGE = `${platformEndpoint}/v1/status-page`
export const STATUS_PAGE_ANALYTICS = `${platformEndpoint}/v1/status-page/analytics`

export const OPENAI_ENDPOINT = `${platformEndpoint}/v1/openai`
